import { render, staticRenderFns } from "./acknowledge.vue?vue&type=template&id=272ab762"
import script from "./acknowledge.vue?vue&type=script&lang=js"
export * from "./acknowledge.vue?vue&type=script&lang=js"
import style0 from "./acknowledge.vue?vue&type=style&index=0&id=272ab762&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports